import React, { FC, ReactNode } from 'react';
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  SxProps,
  Theme,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props {
  summary: ReactNode;
  details: ReactNode;
  expanded: boolean;
  onExpandRequest: () => void;
  sx?: SxProps<Theme>;
}

const Accordion: FC<Props> = ({ summary, details, expanded, onExpandRequest, sx }) => {
  const theme = useTheme();

  return (
    <MuiAccordion
      disableGutters
      expanded={expanded}
      sx={{
        mb: theme.spacing(1),
        borderRadius: `${theme.shape.borderRadius}px`,
        '& .MuiAccordionSummary-root:hover:not(.Mui-disabled)': {
          cursor: 'unset',
        },
        '&:before': {
          position: 'unset',
        },
        ...sx,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon onClick={onExpandRequest} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={{
          flexDirection: 'row-reverse',
          '& .MuiAccordionSummary-expandIconWrapper': {
            mr: theme.spacing(2),
            '& :hover': {
              cursor: 'pointer',
            },
          },
          '& .MuiAccordionSummary-content': {
            justifyContent: 'space-between',
            my: theme.spacing(1),
            '&.Mui-expanded': {
              my: theme.spacing(1),
            },
          },
        }}
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails>{details}</AccordionDetails>
    </MuiAccordion>
  );
};

export default Accordion;
